<template>
  <DragDialog
    title="提示"
    :width="600"
    :visible.sync="visible"
    :footerBtn="[]"
    :cancel="cancel"
    class="inner-pop-primary"
  >
    <div class="tip-box">
      <div class="error-tip-box">
        <div class="icon-box">
          <i class="el-icon-warning"></i>
        </div>
        <div class="msg-box dialog-label">
          该场景内存在已更新的数据集，请更新后再发布
        </div>
      </div>
      <div class="details-box">
        <div class="collapse-box" @click="toggleDetailVisible">
          <icon-svg icon-class="ic-chakanxiangqing" class="icon" />
          <span class="dialog-label">查看详情</span>
          <i
            :class="`el-icon-caret-bottom collapse-icon ${
              isDetailVisible ? 'rotate' : ''
            }`"
          />
        </div>
        <div class="dataset-list-box" v-if="isDetailVisible">
          <div
            v-for="(item, index) in dataSetList"
            :key="index"
            class="item-box"
          >
            {{
              `${dataSetList.length > 1 ? `${index + 1}. ` : ""}${item.name}`
            }}
          </div>
        </div>
      </div>
    </div>
    <div class="common-button-box">
      <el-button class="hollowOut-btn normal-ang-btn" size="small" @click="publish(true)">跳过</el-button>
      <el-button class="primary-btn primary-ang-btn" size="small" type="primary" @click="publish(false)">
        确定
      </el-button>
    </div>
  </DragDialog>
</template>

<script>
import DragDialog from "@/components/CustomDragDialog.vue";

export default {
  data() {
    return {
      isDetailVisible: false,
      dataSetList: [],
    };
  },
  props: {
    visible: Boolean,
    updateDataSets: Array,
    publishScene: Function,
    closeDialog: Function,
  },
  components: {
    DragDialog,
  },
  watch: {
    visible: function (newValue) {
      if (newValue) {
        this.initDataSets();
      }
    },
  },
  methods: {
    initDataSets() {
      let dataSetList = this.updateDataSets.map((item) => {
        let obj = {
          id: item.dataSetId,
          name: item.sceneNodeName,
        };
        return obj;
      });
      this.dataSetList = dataSetList;
    },
    toggleDetailVisible() {
      this.isDetailVisible = !this.isDetailVisible;
    },
    publish(ignoreDataSetUpdate) {
      this.publishScene(ignoreDataSetUpdate);
      this.cancel();
    },
    cancel() {
      this.isDetailVisible = false;
      this.dataSetList = [];
      this.closeDialog();
    },
  },
};
</script>

<style lang="less" scoped>
@import '@/assets/css/publishSearch.less';
.tip-box {
  color: var(--default-color);

  .error-tip-box {
    display: flex;
    align-items: center;
    color: var(--page-tips-text-color);
    .icon-box {
      color: #ec9d00;
      font-size: 18px;
      margin-right: 5px;
    }

    .msg-box {
      margin-left: 5px;
    }
  }

  .details-box {
    margin-top: 10px;

    .collapse-box {
      display: flex;
      align-items: center;
      margin: 10px 0px;
      user-select: none;

      .dialog-label{
        color: var(--tree-expand-icon-color);
      }

      .icon {
        margin-right: 5px;
        margin-bottom: -4px;
        color: var(--tree-expand-icon-color);
      }

      .collapse-icon {
        margin-left: 5px;
        cursor: pointer;
        color: var(--tree-expand-icon-color);
      }

      .rotate {
        transform: rotate(-180deg);
      }
    }

    .dataset-list-box {
      margin: 10px 0px;
      padding: 15px;
      max-height: 200px;
      overflow-y: auto;
      background: var(--base-bg-dark-color33);
      border-radius: 4px;

      .item-box {
        margin: 5px 0px;
        font-size: 14px;
        color: var(--tree-expand-icon-color);
      }
    }
  }
}
.common-button-box {
  text-align: right;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
</style>